import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../lib/usePageMeta';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { BonusBundle } from '../components/BonusBundle';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FloatingCTA } from '../components/FloatingCTA';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  usePageMeta({
    title: 'Más Años Juntos',
    description: 'El Método Maestro de Bio-Nutrición y Convivencia para que tu mascota viva más, mejor y feliz junto a ti.'
  });
  return <div className="min-h-screen bg-cream-light font-sans text-gray-900 pb-24 sm:pb-0" data-id="element-295">
      <FloatingCTA data-id="element-296" />
      <RecentPurchaseToast data-id="element-297" />
      <main data-id="element-298">
        <Hero data-id="element-299" />
        <SocialProof data-id="element-300" />
        <Problem data-id="element-301" />
        <Solution data-id="element-302" />
        <BonusBundle data-id="element-303" />
        <Testimonials data-id="element-304" />
        <Pricing data-id="element-305" />
        <FAQ data-id="element-306" />
      </main>

      <footer className="bg-gray-900 text-white py-12 text-center" data-id="element-307">
        <div className="max-w-7xl mx-auto px-4" data-id="element-308">
          <p className="font-serif text-2xl font-bold mb-4" data-id="element-309">MÁS AÑOS JUNTOS</p>
          <p className="text-gray-400 text-sm mb-8" data-id="element-310">
            El Método Maestro de Bio-Nutrición y Convivencia
          </p>
          <div className="flex justify-center space-x-6 text-sm text-gray-500 mb-8" data-id="element-311">
            <Link to="/terminos" className="hover:text-white transition-colors" data-id="element-312">
              Términos
            </Link>
            <Link to="/privacidad" className="hover:text-white transition-colors" data-id="element-313">
              Privacidad
            </Link>
          </div>
          <p className="text-gray-600 text-xs" data-id="element-314">
            © {new Date().getFullYear()} Más Años Juntos. Todos los derechos
            reservados.
            <br data-id="element-315" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>
    </div>;
}